var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3333 8.00016C19.1243 8.00016 17.3333 9.79103 17.3333 12.0002C17.3333 14.2094 19.1243 16.0002 21.3333 16.0002C23.5425 16.0002 25.3333 14.2094 25.3333 12.0002C25.3333 9.79103 23.5425 8.00016 21.3333 8.00016ZM14.6667 12.0002C14.6667 8.31827 17.6515 5.3335 21.3333 5.3335C25.0152 5.3335 28 8.31827 28 12.0002C28 13.7592 27.3187 15.3592 26.2056 16.5506C28.6601 17.35 30.5568 18.9326 31.7685 20.7107C32.1832 21.3192 32.026 22.1487 31.4175 22.5634C30.8091 22.978 29.9795 22.8208 29.5648 22.2123C28.2639 20.3032 25.8904 18.6668 22.6667 18.6668C17.5547 18.6668 14.6667 22.7658 14.6667 25.3335C14.6667 26.0699 14.0697 26.6668 13.3333 26.6668C12.597 26.6668 12 26.0699 12 25.3335C12 24.4108 12.2113 23.4268 12.6144 22.4568C12.5117 22.391 12.4164 22.3099 12.3319 22.2138C11.2374 20.9684 9.53889 20.0002 7.33335 20.0002C5.1278 20.0002 3.42932 20.9684 2.33485 22.2138C1.84873 22.7668 1.00626 22.8211 0.45314 22.335C-0.0999745 21.8488 -0.154279 21.0064 0.331848 20.4532C1.07871 19.6035 2.02379 18.8487 3.143 18.2944C2.02652 17.2048 1.33335 15.6835 1.33335 14.0002C1.33335 10.6865 4.01964 8.00016 7.33335 8.00016C10.6471 8.00016 13.3333 10.6865 13.3333 14.0002C13.3333 15.6835 12.6402 17.2048 11.5237 18.2944C12.4869 18.7715 13.3211 19.397 14.0111 20.1038C14.8693 19.0214 15.9848 18.0511 17.3229 17.3262C15.7096 16.1094 14.6667 14.1766 14.6667 12.0002ZM4.00001 14.0002C4.00001 12.1592 5.4924 10.6668 7.33335 10.6668C9.17429 10.6668 10.6667 12.1592 10.6667 14.0002C10.6667 15.8411 9.17429 17.3335 7.33335 17.3335C5.4924 17.3335 4.00001 15.8411 4.00001 14.0002Z",
    fill: "#66B929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironments);
export default __webpack_public_path__ + "static/media/environments.9e6a3576ca2222a146ab976950bec64e.svg";
export { ForwardRef as ReactComponent };